import { createStyles, makeStyles } from "@mui/styles";
import { CommonFonts, Colors } from "@/theme";

const useStyles = makeStyles((theme) =>
  createStyles({
    codeText: {
      ...CommonFonts.darkBoldFont14,
      color: Colors.DIM_GREY,
    },
    priceText: {
      ...CommonFonts.darkBoldFont24,
      borderBottom: `1px solid ${Colors.GRAY_BORDER}`,
      minWidth: 90,
      textAlign: "center",
      marginLeft: 5,
      marginRight: 10,
    },
    trendText: {
      fontSize: 14,
      fontWeight: "bold",
    },
    dateText: {
      ...CommonFonts.darkFont12,
      color: Colors.DIM_GREY,
    },
  })
);

export default useStyles;
